// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

let Types = {};

function unwrap_fragment_agentV2(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["VisibleForSalePropertyAgent"]);
}

let fragmentConverter = {"__root":{"agentV2":{"u":"fragment_agentV2"},"":{"f":""}}};

let fragmentConverterMap = {
  fragment_agentV2: unwrap_fragment_agentV2
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

function forSalePropertyMatchingType_decode($$enum) {
  if ($$enum === "BROADCAST" || $$enum === "QUIET_ANONYMOUS" || $$enum === "ONE_WAY" || $$enum === "QUIET") {
    return $$enum;
  }
}

let forSalePropertyMatchingType_fromString = forSalePropertyMatchingType_decode;

let Utils = {
  forSalePropertyMatchingType_decode: forSalePropertyMatchingType_decode,
  forSalePropertyMatchingType_fromString: forSalePropertyMatchingType_fromString
};

let node = ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ConversationPageSelectedConversationContext_forSaleProperty",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nodeId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyLocationForCard_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertyAttributes_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyMlsLabel_propertyV5"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyPageForSalePropertyListingDetails_property"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ForSalePropertyStatus_forSalePropertyV5"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PropertyPrice_property"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "agentV2",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Agent",
              "kind": "LinkedField",
              "name": "agent",
              "plural": false,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "type": "VisibleForSalePropertyAgent",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ConversationPageForSalePropertyLabels_property"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Seller",
      "kind": "LinkedField",
      "name": "client",
      "plural": false,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        }
      ],
      "concreteType": "PropertyImageConnection",
      "kind": "LinkedField",
      "name": "images",
      "plural": false,
      "selections": [
        {
          "kind": "RequiredField",
          "field": {
            "alias": null,
            "args": null,
            "concreteType": "PropertyImageEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "RequiredField",
                "field": {
                  "alias": null,
                  "args": null,
                  "concreteType": "ImageAttachment",
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "RequiredField",
                      "field": {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "crop",
                            "value": false
                          },
                          {
                            "kind": "Literal",
                            "name": "embed",
                            "value": true
                          },
                          {
                            "kind": "Literal",
                            "name": "height",
                            "value": 324
                          },
                          {
                            "kind": "Literal",
                            "name": "width",
                            "value": 324
                          }
                        ],
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": "url(crop:false,embed:true,height:324,width:324)"
                      },
                      "action": "NONE"
                    }
                  ],
                  "storageKey": null
                },
                "action": "NONE"
              }
            ],
            "storageKey": null
          },
          "action": "NONE"
        }
      ],
      "storageKey": "images(first:1)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "matchingType",
      "storageKey": null
    }
  ],
  "type": "ForSalePropertyV5",
  "abstractKey": null
};
})());

let wrap_fragment_agentV2 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_agentV2 = unwrap_fragment_agentV2;
exports.wrap_fragment_agentV2 = wrap_fragment_agentV2;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
